const APP_ORIGIN = 'https://app.teamslyapp.com';

function getOrCreateHeadElement(selector, createElement) {
    const existing = document.head.querySelector(selector);
    if (existing) {
        return { element: existing, created: false };
    }

    const element = createElement();
    document.head.appendChild(element);
    return { element, created: true };
}

export function applyAuthPageMetadata({ title, description, path }) {
    const previousTitle = document.title;
    document.title = title;

    const descriptionTag = getOrCreateHeadElement('meta[name="description"]', () => {
        const element = document.createElement('meta');
        element.setAttribute('name', 'description');
        return element;
    });
    const previousDescription = descriptionTag.element.getAttribute('content');
    descriptionTag.element.setAttribute('content', description);

    const canonicalTag = getOrCreateHeadElement('link[rel="canonical"]', () => {
        const element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        return element;
    });
    const previousCanonical = canonicalTag.element.getAttribute('href');
    canonicalTag.element.setAttribute('href', `${APP_ORIGIN}${path}`);

    return () => {
        document.title = previousTitle;

        if (descriptionTag.created) {
            descriptionTag.element.remove();
        } else if (previousDescription === null) {
            descriptionTag.element.removeAttribute('content');
        } else {
            descriptionTag.element.setAttribute('content', previousDescription);
        }

        if (canonicalTag.created) {
            canonicalTag.element.remove();
        } else if (previousCanonical === null) {
            canonicalTag.element.removeAttribute('href');
        } else {
            canonicalTag.element.setAttribute('href', previousCanonical);
        }
    };
}
